<template>
    <v-dialog
            v-model="fax"
            @close="$emit('close')"
            persistent
            scrollable
            max-width="500"
    >
        <v-card :loading="loading">
            <v-card-title class="grs-card-title px-0">
                <span> {{ $t('fax_details_title') }} </span>

                <v-spacer></v-spacer>

                <v-btn
                        text
                        small
                        icon
                        @click="$emit('close')"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <template v-for="(item, index) in faxActivities">
                <v-list-item :key="index">
                    <template>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{$t("fax_activities_actions." + item.action)}}
                            </v-list-item-title>
                            <v-list-item-subtitle
                                    class="text--primary"
                                    v-text="item.headline"
                            ></v-list-item-subtitle>

                            <v-list-item-subtitle>
                                <span>{{item.technical_note ? item.technical_note : $t(item.description)}}</span>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                            <small>{{ getJalaliDate(item.created_at * 1000, 'HH:mm:ss jYYYY-jMM-jDD') }}</small>
                        </v-list-item-action>
                    </template>
                </v-list-item>
                <v-divider
                        v-if="index < faxActivities.length - 1"
                        :key="index"
                ></v-divider>
            </template>

            <v-list-item v-if="faxActivities.length <= 0">
                <v-list-item-content text="center">
                    اطلاعاتی برای نمایش یافت نشد!
                </v-list-item-content>
            </v-list-item>
        </v-card>
    </v-dialog>
</template>

<script>
    import FaxService from "../services/FaxesService";
    import RequestList from "../services/RequestList";
    // import StorageService from "../services/StorageService";
    // import RequestList from "../services/RequestList";
    // import FaxNumbersService from "../services/FaxNumbers";

    export default {
        props: {
            fax : {
                required: true
            }
        },
        data() {
            return {
                faxActivities : []
            }
        },
        created(){
            this.syncFax();
            this.syncFaxActivities();
        },
        methods: {
            async syncFax(){

            },
            async syncFaxActivities(){
                this.loading = true;
                let requestList = new RequestList();

                requestList.addOrder('id','desc');
                try {
                    let {data} = await FaxService.faxActivities(this.fax.id, requestList);
                    this.faxActivities = data.value.fax_activities;
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>